import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";

const Login = () => {
  const { user, login, completeLogin, checkSession } = useContext(AuthContext);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [code, setCode] = useState("");           // 🔐 Codul 2FA
  const [userId, setUserId] = useState(null);     // 👤 ID-ul utilizatorului
  const [twoFA, setTwoFA] = useState(false);      // 📲 Arătăm inputul pentru cod
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // 👈 Adăugăm un loading state
  const navigate = useNavigate();

  // 🔹 Dacă utilizatorul este deja autentificat, redirecționează-l la dashboard
  if (user) {
    return <Navigate to="/dashboard" />;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.trim() });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    if (!formData.email || !formData.password) {
      setLoading(false);
      setError("⚠️ Email si parola sunt obligatorii!");
      return;
    }

    try {
      const res = await fetch("/api/login.php", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();

      if (res.status !== 200) {
        setError(data.message || "Eroare la autentificare.");
        return;
      }

      if (data.step === "2fa_required") {
        setUserId(data.user_id);
        setTwoFA(true);
      } else if (data.token && data.user) {
        login(data.token, data.user);
      }
    } catch (error) {
      console.error("❌ Eroare la autentificare:", error);
      setError("Eroare retea. Incearcă din nou.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async () => {
    if (!code || !userId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await fetch("/api/verify_2fa.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId, code }),
      });
  
      const data = await res.json();

      if (!data.token || !data.user) {
        setError("Token invalid primit de la server.");
        return;
      }
  
      if (res.status === 200 && data.token && data.user) {
        completeLogin(data.token, data.user);
        await checkSession(); // asigură user complet
        navigate("/dashboard");
      } else {
        setError(data.message || "Cod invalid");
      }
    } catch (error) {
      console.error("❌ Eroare la verificarea codului:", error);
      setError("A apărut o eroare. Încearcă din nou.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/images/Logo.webp" alt="Logo" className="login-logo" />
        <h2>Autentificare</h2>
        {error && <p className="error-message">{error}</p>}

        {!twoFA && (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>E-mail:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <div className="input-group">
              <label>Parola:</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? "Se autentifică..." : "Login"}
            </button>
          </form>
        )}

        {twoFA && (
          <div className="input-group">
            <label>Cod SMS:</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              disabled={loading}
            />
            <button className="login-button" onClick={handleVerifyCode} disabled={loading}>
              {loading ? "Verific..." : "Verifica Codul"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;